import type { DNotificationToast } from "@dfa/ui-platform";
import { callCookieAPI } from "components/utility/cookies/CookiesDIM";
import PromoToast, { type PromoToastProps } from "./promo-toast/PromoToast";
import useMountToast from "./useMountToast";

type ToastSelectorProps<P = unknown> = {
	toastType: "promo"; // Add more when available
} & Omit<Parameters<typeof useMountToast<P>>[0], "component">;

const ToastSelector = ({
	toastType,
	componentProps,
	trigger,
	triggerSettings,
	distance,
	duration
}: ToastSelectorProps<typeof componentProps>) => {
	let component: typeof PromoToast | typeof DNotificationToast | null = null;

	switch (toastType) {
		case "promo": {
			component = PromoToast;
			const promoPosition = "bottom-right";
			const promoProps: PromoToastProps = componentProps;

			if (triggerSettings) {
				triggerSettings.position = promoPosition;
			} else {
				triggerSettings = {
					position: promoPosition,
					autoClose: Number.MAX_SAFE_INTEGER // Using "false" will cause toastify to lose focus and require two clicks
				};
			}

			promoProps.additionalCloseLogic = () =>
				callCookieAPI(window.location.origin + promoProps.cookie.apiEndpoint);

			break;
		}
	}

	useMountToast({ component, componentProps, distance, duration, trigger, triggerSettings });

	return null;
};

export default ToastSelector;
